createSignalIfSupported